import React from "react";
import featuredClients from "../../data/featuredClients.json";

const Section9 = () => {
  return (
    <section className="py-10 md:py-[16]">
      <div className="max-w-6xl mx-auto px-4 text-center">
        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-bold mb-10 text-[#da2128]">
          Featured In
        </h2>

        {/* Centered responsive logo grid using flex */}
        <div className="flex flex-wrap justify-center gap-5 md:gap-12">
          {featuredClients.map((featuredClient, index) => (
            <div
              key={index}
              className="flex items-center justify-center w-40 md:w-44 h-20 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition"
            >
              <a href={featuredClient.url} target="_blank" rel="nofollow">
                <img
                  src={featuredClient.icon}
                  alt={featuredClient.name}
                  className="h-16 object-contain max-w-[144px]"
                />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Section9;
